import HygraphRichText, {
  HygraphRichTextProps,
} from '@/components/hygraph-rich-text';
import { IconColor, IconSize } from '@/components/icons/base-icon';
import PlusIcon from '@/components/icons/plus-icon';
import Typography, { TypographyColor } from '@/components/typography';

export type HowToGroupProps = {
  title: string;
  body: HygraphRichTextProps;
  items: HowToItemProps[];
};

export default function HowTo(props: HowToGroupProps) {
  return (
    <div className='my-4 flex w-full flex-col items-center rounded-lg bg-primary-light px-4 py-8 text-center'>
      <div className='flex flex-col items-center gap-1'>
        <div className='mx-3 flex flex-col gap-2'>
          <Typography.Heading2>{props.title}</Typography.Heading2>
          {props.body && (
            <div className='text-center'>
              <HygraphRichText {...props.body} />
            </div>
          )}
        </div>

        <div className='flex flex-col flex-nowrap gap-4 sm:flex-row'>
          {props.items.map((itemProps, index) => (
            <HowToItem key={index} {...itemProps} />
          ))}
        </div>
      </div>
    </div>
  );
}

export type HowToItemProps = {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  href: string;
  iconUrl: string;
};

const HowToItem = (props: HowToItemProps) => (
  <a
    href={props.href}
    target='_blank'
    rel='noreferrer'
    className='h-70 flex w-full flex-col justify-center gap-6 rounded-2xl bg-white p-6 text-center shadow-md'
  >
    <Typography.Heading5>{props.title}</Typography.Heading5>

    <Typography.Body1
      weight='medium'
      color={TypographyColor.PRIMARY}
      className='flex items-center justify-center'
      overline
      overlineClassName='mx-auto'
    >
      <PlusIcon inline size={IconSize.SMALL} color={IconColor.INHERIT} />
      {props.subtitle}
    </Typography.Body1>
  </a>
);
